import { Http } from '@pirates/not-morty-biz';
import i18n from '@/localization/i18n';
import store from '@/store';
import { keycloakB2C } from '@/services/auth/auth.service';
import { migrationEndpoints } from './migration.config';
import { AGB, LegalEntityConsent } from './migration.types';
import { Store } from 'vuex';
import { legalEntityToCity } from '@/data/country.config';

export const loadTermsAndConditions = async (locale: string = i18n.locale, legalEntityId?: number) => {
  try {
    let location = '';
    if (legalEntityId) {
      location = legalEntityToCity[legalEntityId] ? `&location=${legalEntityToCity[legalEntityId]}` : '';
    }

    const migrationTnC = await Http.get<AGB>(`/api/web/beth/sharenow/contentCollection/b2bLegal?language=${locale}${location}`);

    return migrationTnC;
  } catch (err) {
    store.dispatch('app/showServerError', err);
  }
};

export const loadLegalEntityMigrationConsents = async (legalEntityId: number): Promise<LegalEntityConsent[] | undefined> => {
  try {
    const legalEntityMigrationConsents: { data: LegalEntityConsent[] } = await Http.get(migrationEndpoints.legalEnityMigrationConsnets(legalEntityId));
    return legalEntityMigrationConsents.data;
  } catch (err) {
    store.dispatch('app/showServerError', err);
  }
};

export const shareNowLogout = (store?: Store<any>) => {
  keycloakB2C.logout(store, {
    redirectUri: `${process.env.VUE_APP_BASE_URL}${process.env.VUE_APP_BASE_PATH}`,
  });
};
